// Page-scoped row selection for the admin tables. A new Set is returned on
// every change so React sees the update; callers must not mutate the set.

export const toggleId = (selected, id) => {
  const next = new Set(selected);
  if (next.has(id)) next.delete(id);
  else next.add(id);
  return next;
};

export const selectionOnPage = (selected, ids) => {
  const count = ids.reduce((total, id) => total + (selected.has(id) ? 1 : 0), 0);
  return {
    count,
    all: ids.length > 0 && count === ids.length,
    some: count > 0 && count < ids.length
  };
};

// Selects every id on the page, or clears them when they are already all selected.
export const togglePageIds = (selected, ids) => {
  const next = new Set(selected);
  const { all } = selectionOnPage(selected, ids);
  ids.forEach((id) => {
    if (all) next.delete(id);
    else next.add(id);
  });
  return next;
};

// Runs one action per row, in order, so follow-up work (reader resync, for
// example) cannot race itself. One failure does not stop the rest.
export const runBulk = async (items, action) => {
  let ok = 0;
  let failed = 0;
  for (const item of items) {
    try {
      await action(item);
      ok += 1;
    } catch {
      failed += 1;
    }
  }
  return { ok, failed };
};

export const summarizeBulk = (past, noun, { ok, failed }, plural = `${noun}s`) => {
  const label = `${ok} ${ok === 1 ? noun : plural}`;
  if (failed === 0) return `${past} ${label}.`;
  return `${past} ${label}. ${failed} could not be updated.`;
};
